export * from './critical-values-table.component';
export * from './normal-distribution-diagram.component';
export * from './critical-table-dialog.component';
export * from './critical-table-dialog.service';
